import {
  IonContent,
  IonPage,
  IonHeader,
  IonToolbar,
  IonButtons,
  IonBackButton,
  IonTitle,
  IonCard,
  IonCardHeader,
  IonCardTitle,
  IonCardContent,
  IonList,
  IonItem,
  IonLabel,
  IonIcon,
} from '@ionic/react';
import { UserProfile } from '@clerk/clerk-react';
import { useHistory } from 'react-router-dom';
import {
  documentTextOutline,
  shieldCheckmarkOutline,
  shieldOutline,
} from 'ionicons/icons';
import { usePageView } from '../hooks/useLoggerInit';
import { useI18n } from '../i18n/I18nProvider';
import { APP_VERSION, BUILD_DATE, GIT_COMMIT, GIT_BRANCH } from '../version';

const ProfilePage: React.FC = () => {
  const history = useHistory();
  usePageView('profile');
  const { t } = useI18n();

  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
          <IonButtons slot="start">
            <IonBackButton
              defaultHref="/dashboard"
              text={t('common.actions.back')}
            />
          </IonButtons>
          <IonTitle>{t('profile.title')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      
      <IonContent fullscreen className="ion-padding">
        <div className="profile-container">
          <UserProfile
            appearance={{
              elements: {
                rootBox: {
                  width: '100%',
                  maxWidth: '600px',
                  margin: '0 auto',
                },
                card: {
                  boxShadow: 'none',
                  border: 'none',
                },
                navbar: {
                  borderRight: 'none',
                },
                navbarButton: {
                  borderRadius: '8px',
                },
                formButtonPrimary: {
                  backgroundColor: 'var(--ion-color-primary)',
                  borderRadius: '12px',
                },
                formFieldInput: {
                  borderRadius: '12px',
                },
              },
            }}
          />
        </div>

        <IonCard>
          <IonCardHeader>
            <IonCardTitle>{t('dashboard.legal.title')}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonList lines="none">
              <IonItem button onClick={() => history.push('/terms')}>
                <IonIcon icon={documentTextOutline} slot="start" color="medium" />
                <IonLabel>{t('dashboard.legal.terms')}</IonLabel>
              </IonItem>
              <IonItem button onClick={() => history.push('/privacy')}>
                <IonIcon icon={shieldCheckmarkOutline} slot="start" color="medium" />
                <IonLabel>{t('dashboard.legal.privacy')}</IonLabel>
              </IonItem>
              <IonItem button onClick={() => history.push('/settings/data')} detail>
                <IonIcon icon={shieldOutline} slot="start" color="medium" />
                <IonLabel>{t('dashboard.privacyData.title')}</IonLabel>
              </IonItem>
            </IonList>
          </IonCardContent>
        </IonCard>

        <IonCard>
          <IonCardHeader>
            <IonCardTitle>{t('dashboard.appInfo.title')}</IonCardTitle>
          </IonCardHeader>
          <IonCardContent>
            <IonList lines="none">
              <IonItem>
                <IonLabel>
                  <p>{t('dashboard.appInfo.version')}</p>
                  <h3>{APP_VERSION}</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <p>{t('dashboard.appInfo.buildDate')}</p>
                  <h3>{new Date(BUILD_DATE).toLocaleString()}</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <p>{t('dashboard.appInfo.gitBranch')}</p>
                  <h3>{GIT_BRANCH}</h3>
                </IonLabel>
              </IonItem>
              <IonItem>
                <IonLabel>
                  <p>{t('dashboard.appInfo.gitCommit')}</p>
                  <h3>{GIT_COMMIT}</h3>
                </IonLabel>
              </IonItem>
            </IonList>
          </IonCardContent>
        </IonCard>

        <style>{`
          .profile-container {
            min-height: auto;
            padding-bottom: 24px;
          }
          ion-list ion-item {
            --padding-start: 0;
          }
          ion-list ion-item p {
            font-size: 12px;
            color: var(--ion-color-medium);
          }
          ion-list ion-item h3 {
            font-size: 16px;
            font-weight: 500;
          }
        `}</style>
      </IonContent>
    </IonPage>
  );
};

export default ProfilePage;
